/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigCheckbox
 */
export interface BidirectionalActionConfigCheckbox {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    _default: boolean;
}

/**
 * Check if a given object implements the BidirectionalActionConfigCheckbox interface.
 */
export function instanceOfBidirectionalActionConfigCheckbox(value: object): value is BidirectionalActionConfigCheckbox {
    if (!('name' in value) || value['name'] === undefined) return false;
    if ((!('_default' in (value as Record<string, any>)) && !('default' in (value as Record<string, any>))) || ((value as Record<string, any>)['_default'] === undefined && (value as Record<string, any>)['default'] === undefined)) return false;
    return true;
}

export function BidirectionalActionConfigCheckboxFromJSON(json: any): BidirectionalActionConfigCheckbox {
    return BidirectionalActionConfigCheckboxFromJSONTyped(json, false);
}

export function BidirectionalActionConfigCheckboxFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigCheckbox {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        '_default': json['default'],
    };
}

export function BidirectionalActionConfigCheckboxToJSON(json: any): BidirectionalActionConfigCheckbox {
    return BidirectionalActionConfigCheckboxToJSONTyped(json, false);
}

export function BidirectionalActionConfigCheckboxToJSONTyped(value?: BidirectionalActionConfigCheckbox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'default': value['_default'],
    };
}

